import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonServiceService } from './../../core/services/common-service/common-service.service';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from './../../core/services/auth/auth.service';
import { SanitizeService } from 'src/app/shared/services/sanitize.service';
import { ToastrService } from 'ngx-toastr';
interface Topic {
    name: string;
    id: number;
    isOrganisationalLabel: boolean;
    isArticleCountToZero: boolean;
    keyConcept: Array<KeyConcept>;
    subtopics: Array<Topic>;
    sources: Array<any>;
    sourceParams: SourceParams;
    sourcesSubTopic: SourcesSubTopic;
    exportDocumentRules: any;
    parentSearchContextList: Array<number>;
    parentRelContextList: Array<number>;
    globalRelevance: boolean;
    processNonArticles: boolean;
    skipRelevance: boolean;
    suppressSummary: boolean;
    suppressMDS?: boolean;
    ignoreProcess?: boolean;
    dor?: any;
    intentScore?: any;
    level: number;
    showAddIcon: boolean;
    ParentList: Array<number>;
    ParentValueChanged: boolean;
    isTemplate: boolean;
}

interface KeyConcept {
    name: string;
    isSearch: boolean;
    isRelevance: boolean;
}

interface SourceParams {
    [key: string]: any;
}

interface SourcesSubTopic {
    repoIds: { [key: string]: any };
    repoAvailable: boolean;
    knowledgeStoreIds: { [key: string]: any };
    includeSubTopic: { [key: string]: boolean };
    webAvailable: boolean;
    favouriteWebsites: Array<string>;
    dispreferredWebsites: Array<string>;
}
@Component({
    selector: 'app-gyan-input',
    templateUrl: './gyan-input.component.html',
    styleUrls: ['./gyan-input.component.scss'],
})
export class GyanInputComponent implements OnInit {
    @Input() topic!: Topic;
    @Input() parentTopic!: Topic; // reference to the parent topic
    @Input() grandParentTopic?: Topic; //  reference to the grandparent topic
    @Input() pathIndices: Array<number> = [];
    @Output() save = new EventEmitter<void>();
    @Output() saveSubTopicSources = new EventEmitter<{ topicId: number; topic: Topic }>();
    @Output() saveKeyConcepts = new EventEmitter<{ topicId: number; keyConcepts: Array<KeyConcept> }>();
    @Output() saveTemplates = new EventEmitter<{ topicId: number; topics: Array<Topic> }>();
    @Output() saveSettingsParams = new EventEmitter<{ topicId: number; settings: any }>();
    currentTopic!: Topic;
    gksLevel: string = 'gyanLevel';
    @ViewChild('topicInput') topicInputElement!: ElementRef; // Reference to the input element
    isFocused: boolean = false; // if the current input is focused
    isClickingAdd: boolean = false; // if the plus icon is being clicked
    showMenu: boolean = false; // show menu for 3 dots
    activeMenuId: number | null = null; // get the ID of the currently active menu
    @ViewChild('menuDropdown', { static: false }) menuDropdown!: ElementRef; // Referencing the menu dropdown
    private menuSubscription: Subscription;
    faEllipsisV = faEllipsisV;

    showKeyPopup: boolean = false;
    keyConcepts: Array<KeyConcept> = [];
    currentTopicId!: number;

    private modalRef: NgbModalRef | undefined;
    private boundCloseMenuOnOutsideClick: ((event: MouseEvent) => void) | undefined;
    private isClosing: boolean = false;

    GyanTemplatesPermission: boolean = false;
    KeyConceptsPermission: boolean = false;
    TocSettingsPermission: boolean = false;
    TopicLevelSourcingPermission: boolean = false;
    sourcesData: any;
    isMobile = false;
    isThreeDotsHovered = false;
    private previousValue: string = '';

    constructor(
        private cdr: ChangeDetectorRef,
        private commonServiceService: CommonServiceService,
        private modalService: NgbModal,
        private authservice: AuthService,
        private sanitizeService: SanitizeService,
        private toastrService: ToastrService,
    ) {
        this.menuSubscription = this.commonServiceService.menuState$.subscribe((openMenuId) => {
            this.showMenu = openMenuId === this.topic.id;
            this.cdr.detectChanges();
        });
    }

    ngOnInit() {
        if (this.topic == null) {
            this.topic = this.createInitialTopic();
        }
        //   console.log("ngOnInitcalled for gyanInput")
        this.accesList();
        this.checkWidth();
        //    console.log('pageloaded');
    }

    createInitialTopic(): Topic {
        return {
            name: '',
            id: Date.now(),
            isOrganisationalLabel: false,
            isArticleCountToZero: false,
            keyConcept: [],
            subtopics: [],
            sources: [],
            sourceParams: {},
            sourcesSubTopic: {
                repoIds: {},
                repoAvailable: true,
                knowledgeStoreIds: {},
                includeSubTopic: {},
                webAvailable: false,
                favouriteWebsites: [],
                dispreferredWebsites: [],
            },
            exportDocumentRules: null,
            parentSearchContextList: [],
            parentRelContextList: [],
            globalRelevance: true,
            processNonArticles: false,
            skipRelevance: false,
            suppressSummary: false,
            suppressMDS: false,
            ignoreProcess: false,
            dor: null,
            intentScore: null,
            level: 0,
            showAddIcon: false,
            ParentList: [],
            ParentValueChanged: false,
            isTemplate: false,
        };
    }

    accesList() {
        // console.log(this.authservice);
        this.GyanTemplatesPermission = this.authservice.getAccessList('Templates');
        this.KeyConceptsPermission = this.authservice.getAccessList('KeyConcepts');
        this.TopicLevelSourcingPermission = this.authservice.getAccessList('TopicOutlineSources');
        this.TocSettingsPermission = this.authservice.getAccessList('CreateGyanSettings');
    }

    ngAfterViewInit(): void {
        //  console.log("ngAfterViewInit for GyanInput form")
        // Focus on the input after the view has initialized

        // if(localStorage.getItem('isTemplate') == "true"){
        //      //removing focus
        //     this.isFocused = false;
        // }else{
        setTimeout(() => {
            this.focusInput();
        }, 0);
        //}

        if (this.menuDropdown) {
            console.log('menuDropdown is initialized:', this.menuDropdown.nativeElement);
        }
    }

    focusInput(): void {
        if (this.topicInputElement) {
            //  console.log("focusInput for GyanInput form")
            this.topicInputElement.nativeElement.focus(); // Focus the input element
        }
    }

    addSubtopic(): void {
        // console.log('Add subtopic called');\
        console.log(this.parentTopic);

        console.log('old', this.topic);
        const newSubtopic: Topic = {
            name: '',
            id: Date.now(),
            isOrganisationalLabel: false,
            isArticleCountToZero: false,
            keyConcept: [],
            subtopics: [],
            sources: [],
            sourceParams: {},
            sourcesSubTopic: {
                repoIds: {},
                repoAvailable: true,
                knowledgeStoreIds: {},
                includeSubTopic: {},
                webAvailable: false,
                favouriteWebsites: [],
                dispreferredWebsites: [],
            },
            exportDocumentRules: null,
            parentSearchContextList: [],
            parentRelContextList: [],
            globalRelevance: true,
            processNonArticles: false,
            skipRelevance: false,
            suppressSummary: false,
            suppressMDS: false,
            ignoreProcess: false,
            dor: null,
            intentScore: null,
            level: this.topic.level === 0 ? this.topic.level + 1 : this.topic.level,
            showAddIcon: false,
            ParentList: [],
            ParentValueChanged: false,
            isTemplate: false,
        };
        //this.save.emit();
        console.log('Final SubTopicData', newSubtopic);
        if (this.parentTopic) {
            const currentIndex = this.parentTopic.subtopics.findIndex((sub) => sub.id === this.topic.id);
            if (currentIndex === -1) {
                console.error('Current topic not found in parent subtopics.');
                return;
            }
            // if (this.topic.subtopics.length > 0) {
            //     //    console.log('if');
            //     // If there are already child subtopics, insert at the beginning
            //     this.parentTopic.subtopics.unshift(newSubtopic);
            // } else {
            //     //    console.log('else');
            //     // Otherwise, add it to the end
            //     //this.parentTopic.subtopics.push(newSubtopic);

            this.parentTopic.subtopics.splice(currentIndex + 1, 0, newSubtopic);

            //     // let currentIndex = arr.indexOf(value);
            //     // this.parentTopic.subtopics.splice(newSubtopic);
            // }
        } else {
            // if (this.topic.subtopics.length > 0) {
            //     //    console.log('if');
            //     // If there are already child subtopics, insert at the beginning
            //     this.topic.subtopics.unshift(newSubtopic);
            // } else {
            //     //    console.log('else');
            //     // Otherwise, add it to the end
            this.topic.subtopics.push(newSubtopic);
            // }
        }
        console.log('new', this.topic);
        //
        this.isClickingAdd = false; // Reset the click flag after adding
        this.cdr.detectChanges();
        //setTimeout(() => this.focusInput(), 0);
    }

    addSubtopicMobile(): void {
        // console.log('Add subtopic called');\
        console.log(this.parentTopic);

        console.log('old', this.topic);
        const newSubtopic: Topic = {
            name: '',
            id: Date.now(),
            isOrganisationalLabel: false,
            isArticleCountToZero: false,
            keyConcept: [],
            subtopics: [],
            sources: [],
            sourceParams: {},
            sourcesSubTopic: {
                repoIds: {},
                repoAvailable: true,
                knowledgeStoreIds: {},
                includeSubTopic: {},
                webAvailable: false,
                favouriteWebsites: [],
                dispreferredWebsites: [],
            },
            exportDocumentRules: null,
            parentSearchContextList: [],
            parentRelContextList: [],
            globalRelevance: true,
            processNonArticles: false,
            skipRelevance: false,
            suppressSummary: false,
            suppressMDS: false,
            ignoreProcess: false,
            dor: null,
            intentScore: null,
            level: this.topic.level + 1,
            showAddIcon: false,
            ParentList: [],
            ParentValueChanged: false,
            isTemplate: false,
        };
        //this.save.emit();
        console.log('Final SubTopicData', newSubtopic);

        if (this.topic.subtopics.length > 0) {
            //    console.log('if');
            // If there are already child subtopics, insert at the beginning
            this.topic.subtopics.unshift(newSubtopic);
        } else {
            //    console.log('else');
            // Otherwise, add it to the end
            this.topic.subtopics.push(newSubtopic);
        }
        console.log('new', this.topic);
        //
        this.isClickingAdd = false; // Reset the click flag after adding
        this.cdr.detectChanges();
        //setTimeout(() => this.focusInput(), 0);
    }

    sendTopicName() {
        //    console.log('this.topic.name.trim()', this.topic.name.trim());
        const sanitizedValue = this.sanitizeService.sanitizeInput(this.topic.name);

        // Only update and emit if the sanitized value differs
        if (this.topic.name !== sanitizedValue) {
            this.topic.name = sanitizedValue;
        }

        this.commonServiceService.setTopicName(this.topic.name.trim());
    }

    onPaste(event: ClipboardEvent): void {
        event.preventDefault();

        if (event.clipboardData) {
            const pastedData = event.clipboardData.getData('text');
            const sanitizedData = this.sanitizeService.sanitizeInput(pastedData);
            if (pastedData !== sanitizedData) {
                this.toastrService.warning('Invalid characters are not allowed');
            }
            this.topic.name = sanitizedData;
        }
    }

    sanitizeInput(event: any) {
        const gyanTitle = (event.target as HTMLInputElement).value;
        // console.log('the string is', gyanTitle);
        this.commonServiceService.callValidationForSubmitGyanFromSubtopic(true);
        const sanitizedData = this.sanitizeService.sanitizeInput(gyanTitle);
        if (gyanTitle !== sanitizedData) {
            this.toastrService.warning('Invalid characters are not allowed');
        }
        (event.target as HTMLInputElement).value = sanitizedData;
    }

    onKeydown(event: Event): void {
        const keyboardEvent = event as KeyboardEvent; // Explicitly cast to KeyboardEvent
        // console.log("this.topic.name.trim()", this.topic.name.trim())
        const currentValue = (event.target as HTMLInputElement).value;
        //   console.log('currentValue', currentValue);

        this.commonServiceService.setTopicName(currentValue);
        if (keyboardEvent.key === 'Enter' && currentValue !== '') {
            console.log('enter pressed');
            event.preventDefault();
            //const trimmedName = this.topic.name.trim();
            //if (this.previousValue !== trimmedName)
            this.saveCurrentValue();

            //this.addSubtopic();
            if (this.isMobile) this.addSubtopicMobile();
            else this.addSubtopic();
        } else if (keyboardEvent.key === 'Tab' && keyboardEvent.shiftKey) {
            event.preventDefault();
            this.topic.ParentValueChanged = false;
            //if (currentValue === '')
            this.moveToLeft();
            //   this.commonServiceService.loadFromLocalStorage();
        } else if (keyboardEvent.key === 'Tab' && !keyboardEvent.shiftKey) {
            event.preventDefault();
            this.topic.ParentValueChanged = false;
            //if (currentValue === '')
            this.moveToRight();
            //   this.commonServiceService.loadFromLocalStorage();
        } else if (keyboardEvent.key === 'Backspace') {
            this.handleBackspace(keyboardEvent); // Handle backspace behavior
        }
    }

    generateDataId(topic: any, pathIndices: Array<number> = []): string {
        // Combine all indices in the path to create a hierarchical ID
        return pathIndices.length === 0 ? 'parent' : 'parent-' + pathIndices.map((index) => `${index}`).join('-');
    }

    onFocus(): void {
        this.isFocused = true;
        this.previousValue = this.topic.name.trim();
        console.log('this.previousValue', this.previousValue);
    }

    onAddIconClick(): void {
        this.isClickingAdd = true;
        if (this.isMobile) this.addSubtopicMobile();
        else this.addSubtopic();
    }

    onBlur(event: Event): void {
        event.preventDefault();

        //console.log('blur triggered');
        if (this.isClickingAdd) {
            return; // Do nothing if the plus icon is being clicked
        }

        this.isFocused = false;

        // // // Check if the value of the topic has changed
        // const trimmedName = this.topic.name.trim();
        // if (this.previousValue === trimmedName && this.previousValue !== '') {
        //     console.log('No changes detected in topic name, skipping blur logic.');
        //     return; // exit if the value has not changed
        // }

        // this.previousValue = trimmedName;

        // if (trimmedName === '') {
        //     this.removeEmptyTopic();
        // } else {
        //     this.saveCurrentValue();
        // }

        if (this.topic.name.trim() === '') {
            this.removeEmptyTopic();
        } else {
            //this.save.emit();
            //removed the below condition to avoid override the parent value
            this.saveCurrentValue();
        }

        this.commonServiceService.callValidationForSubmitGyanFromSubtopic(true);
    }

    handleBackspace(event: KeyboardEvent): void {
        if (event.key === 'Backspace' && this.topic.name.trim() === '') {
            event.preventDefault();
            this.removeEmptyTopic(); // Call method to remove the current topic
            this.saveCurrentValue();
            this.commonServiceService.callValidationForSubmitGyanFromSubtopic(true);
        }
    }

    removeEmptyTopic(): void {
        if (this.parentTopic) {
            const index = this.parentTopic.subtopics.findIndex((sub) => sub.id === this.topic.id);
            if (index !== -1) {
                this.parentTopic.subtopics.splice(index, 1);
            }
            this.save.emit(); // Trigger save to update localStorage
        } else {
            // If no parentTopic, this is the main topic, handle it differently
            this.clearRootTopic();
        }
    }

    clearRootTopic(): void {
        // debugger;
        // Clear all and reset the localStorage
        this.topic.name = '';
        this.topic.subtopics = [];
        this.topic.keyConcept = [];
        (this.topic.isOrganisationalLabel = false),
            (this.topic.isArticleCountToZero = false),
            (this.topic.sources = []),
            (this.topic.sourceParams = {}),
            (this.topic.sourcesSubTopic = {
                repoIds: {},
                repoAvailable: true,
                knowledgeStoreIds: {},
                includeSubTopic: {},
                webAvailable: false,
                favouriteWebsites: [],
                dispreferredWebsites: [],
            }),
            (this.topic.exportDocumentRules = null),
            (this.topic.parentSearchContextList = []),
            (this.topic.parentRelContextList = []),
            (this.topic.globalRelevance = true),
            (this.topic.processNonArticles = false),
            (this.topic.skipRelevance = false),
            (this.topic.suppressSummary = false),
            (this.topic.suppressMDS = false),
            (this.topic.ignoreProcess = false),
            (this.topic.dor = null),
            (this.topic.intentScore = null),
            (this.topic.level = 0);
        this.topic.showAddIcon = false;
        this.topic.ParentList = [];
        this.topic.ParentValueChanged = false;
        this.topic.isTemplate = false;
        localStorage.removeItem('topicOutline');
        this.commonServiceService.setTopicName(this.topic.name.trim());
        this.save.emit(); // Trigger save to update localStorage
    }

    /* eslint-disable sonarjs/cognitive-complexity */
    saveCurrentValue(): void {
        // debugger;
        console.log('saveCurrentValue', this.topic);
        if (this.topic.name.trim() !== '') {
            if (!this.topic.isOrganisationalLabel) {
                console.log('coming here inside - 1', this.topic, this.parentTopic);
                // console.log(this.topic);
                if (!this.topic.ParentValueChanged) {
                    console.log('coming here inside - 2');
                    if (this.topic.isTemplate) {
                        console.log('coming here inside - 3');
                        if (this.topic.parentSearchContextList !== null) {
                            console.log('coming here inside - 4');
                            // this is for template patent
                            if (this.topic.parentRelContextList.length == 0) {
                                this.topic.parentSearchContextList = [];
                                this.topic.parentRelContextList = [];
                                this.topic.ParentList = this.parentTopic ? this.getAllParentIds(this.parentTopic.id) : [];
                            } else if (this.topic.parentRelContextList.length > 0) {
                                this.topic.parentSearchContextList = this.parentTopic ? this.getAllParentIdsContextList(this.parentTopic.id) : [];
                                this.topic.parentRelContextList = this.parentTopic ? this.getAllParentIdsContextList(this.parentTopic.id) : [];
                                this.topic.ParentList = this.parentTopic ? this.getAllParentIds(this.parentTopic.id) : [];
                            }
                        } else {
                            if (this.topic.parentSearchContextList == null) {
                                console.log('coming here inside - 5');
                                //this is for template that has empty parentcontext (Person)
                                this.topic.parentSearchContextList = this.parentTopic ? this.getAllParentIdsContextList(this.parentTopic.id) : [];
                                this.topic.parentRelContextList = this.parentTopic ? this.getAllParentIdsContextList(this.parentTopic.id) : [];
                                this.topic.ParentList = this.parentTopic ? this.getAllParentIds(this.parentTopic.id) : [];
                            }
                        }
                    } else {
                        console.log('coming here inside - 6');
                        //normal case
                        this.topic.parentSearchContextList = this.parentTopic ? this.getAllParentIdsContextList(this.parentTopic.id) : [];
                        this.topic.parentRelContextList = this.parentTopic ? this.getAllParentIdsContextList(this.parentTopic.id) : [];
                        this.topic.ParentList = this.parentTopic ? this.getAllParentIds(this.parentTopic.id) : [];
                    }
                } else {
                    this.topic.parentSearchContextList = this.topic.parentSearchContextList;
                    this.topic.parentRelContextList = this.topic.parentRelContextList;
                    this.topic.ParentList = this.parentTopic ? this.getAllParentIds(this.parentTopic.id) : [];
                }
                console.log('isOrganisationalLabel false');
            } else {
                console.log('isOrganisationalLabel true');
                this.topic.parentSearchContextList = [];
                this.topic.parentRelContextList = [];
                this.topic.ParentList = this.parentTopic ? this.getAllParentIds(this.parentTopic.id) : [];
            }
            if (this.topic.isArticleCountToZero) {
                console.log('isArticleCountToZero true');
                this.topic.parentSearchContextList = [];
                this.topic.parentRelContextList = [];
                this.topic.ParentList = this.parentTopic ? this.getAllParentIds(this.parentTopic.id) : [];
            }
            this.save.emit();
            // this.commonServiceService.loadFromLocalStorage();
        }
    }

    // // comma-separated list of parent IDs
    getAllParentIds(topicId: number): Array<number> {
        const parentIds: Array<number> = [];

        const storedData = localStorage.getItem('topicOutline');
        if (!storedData) {
            console.error('No topic data found in localStorage.');
            return parentIds; // return empty if no data is found
        }

        const rootTopic: Topic = JSON.parse(storedData);

        // find form topic id
        let currentTopic = this.findTopicById(topicId, [rootTopic]);

        //getting parent ids
        while (currentTopic) {
            parentIds.unshift(currentTopic.id); // adding current topic at starting position
            //console.log('parentIds so far:', parentIds);

            // finding parent of current topic
            currentTopic = this.getParentTopic(currentTopic.id, [rootTopic]);
        }

        //console.log('Final list of parent IDs:', parentIds);
        return parentIds; // returning final array
    }

    getParentTopic(topicId: number, topics: Array<Topic>): Topic | undefined {
        for (const topic of topics) {
            if (topic.subtopics.some((sub) => sub.id === topicId)) {
                return topic; // return in parent found
            }

            // recursively check subtopics for the parent
            const parent = this.getParentTopic(topicId, topic.subtopics);
            if (parent) {
                return parent;
            }
        }
        return undefined; // return undefined if no parent is found
    }

    getAllParentIdsContextList(topicId: number): Array<number> {
        const parentIds: Array<number> = [];

        const storedData = localStorage.getItem('topicOutline');
        if (!storedData) {
            console.error('No topic data found in localStorage.');
            return parentIds; // return empty if no data is found
        }

        const rootTopic: Topic = JSON.parse(storedData);

        // find form topic id
        let currentTopic = this.findTopicById(topicId, [rootTopic]);

        //getting parent ids
        while (currentTopic) {
            if (!currentTopic.isOrganisationalLabel) parentIds.unshift(currentTopic.id); // adding current topic at starting position
            //console.log('parentIds so far:', parentIds);

            // finding parent of current topic
            currentTopic = this.getParentTopic(currentTopic.id, [rootTopic]);
        }

        //console.log('Final list of parent IDs:', parentIds);
        return parentIds; // returning final array
    }

    moveToLeft(): void {
        if (this.parentTopic && this.grandParentTopic) {
            const index = this.parentTopic.subtopics.findIndex((sub) => sub.id === this.topic.id);
            if (index !== -1) {
                // Remove current topic from parent's subtopics
                // const removedTopic = this.parentTopic.subtopics.splice(index, 1)[0];
                // removedTopic.level -= 1; // Decrease the level of the current topic

                const [removedTopic] = this.parentTopic.subtopics.splice(index, 1);
                // Update the level for the removed topic and its subtopics
                this.updateTopicLevels(removedTopic, removedTopic.level - 1);

                // Move as a sibling of the parent (under the grandparent)
                this.grandParentTopic.subtopics.push(removedTopic);
                this.saveCurrentValue();
            }
        } else if (this.parentTopic && !this.grandParentTopic && this.parentTopic.level > 0) {
            // Move to top-level only if not already at the top-level
            const index = this.parentTopic.subtopics.findIndex((sub) => sub.id === this.topic.id);
            if (index !== -1) {
                // const removedTopic = this.parentTopic.subtopics.splice(index, 1)[0];
                // removedTopic.level -= 1; // Decrease the level of the current topic

                const [removedTopic] = this.parentTopic.subtopics.splice(index, 1);

                // Update the level for the removed topic and its subtopics
                this.updateTopicLevels(removedTopic, removedTopic.level - 1);

                this.parentTopic.subtopics.push(removedTopic);
                this.saveCurrentValue();
            }
        }
    }

    moveToRight(): void {
        if (this.parentTopic) {
            const index = this.parentTopic.subtopics.findIndex((sub) => sub.id === this.topic.id);
            if (index !== -1 && index > 0) {
                // Move to be a child of the previous sibling
                // const removedTopic = this.parentTopic.subtopics.splice(index, 1)[0];
                // const previousSibling = this.parentTopic.subtopics[index - 1];
                // removedTopic.level += 1; // Increase the level of the current topic

                // Move to be a child of the previous sibling
                const [removedTopic] = this.parentTopic.subtopics.splice(index, 1);
                const previousSibling = this.parentTopic.subtopics[index - 1];

                // Update the level for the removed topic and its subtopics
                this.updateTopicLevels(removedTopic, removedTopic.level + 1);

                previousSibling.subtopics.push(removedTopic);
                this.saveCurrentValue();
            }
        }
    }

    updateTopicLevels(topic: Topic, newLevel: number): void {
        topic.level = newLevel;
        topic.subtopics.forEach((subtopic) => this.updateTopicLevels(subtopic, newLevel + 1));
    }

    toggleMenu(event: MouseEvent): void {
        event.stopPropagation();

        if (this.isClosing) {
            return;
        }

        if (this.showMenu) {
            this.showMenu = false;
            this.commonServiceService.closeMenu();

            if (this.boundCloseMenuOnOutsideClick) {
                document.removeEventListener('click', this.boundCloseMenuOnOutsideClick, true);
            }
        } else {
            this.showMenu = true;
            this.commonServiceService.openMenu(this.topic.id);

            if (!this.boundCloseMenuOnOutsideClick) {
                this.boundCloseMenuOnOutsideClick = this.closeMenuOnOutsideClick.bind(this);
            }
            document.addEventListener('click', this.boundCloseMenuOnOutsideClick, true);
        }
    }

    closeMenuOnOutsideClick(event: MouseEvent): void {
        console.log('closeMenuOnOutsideClick called');

        if (this.menuDropdown && this.menuDropdown.nativeElement) {
            const clickedInside = this.menuDropdown.nativeElement.contains(event.target);
            if (!clickedInside) {
                this.showMenu = false;
                this.commonServiceService.closeMenu();
                this.isClosing = true;
                setTimeout(() => {
                    this.isClosing = false;
                }, 100);
                if (this.boundCloseMenuOnOutsideClick) {
                    document.removeEventListener('click', this.boundCloseMenuOnOutsideClick, true);
                }
            }
        }
    }

    showPopup(option: string, topicId: number, content: any, popupSize: string): void {
        this.gksLevel = 'topicLevel';
        this.activeMenuId = null; // Close the menu after selection
        console.log(`Selected option: ${option} for topic ID: ${topicId}`);
        this.currentTopicId = topicId;
        // if(option === "keyConcept"){
        this.currentTopic = this.topic;
        this.loadTopicFromLocalStorage();
        // }
        this.commonServiceService.closeMenu();
        console.log('show popup', option);
        this.modalRef = this.modalService.open(content, { size: popupSize, windowClass: 'modal-settings' });
    }

    onSaveKeyConcepts(keyConcepts: Array<KeyConcept>): void {
        console.log(keyConcepts);
        this.keyConcepts = keyConcepts;
        this.showKeyPopup = false;
        console.log(this.currentTopicId);
        // this.loadTopicFromLocalStorage();
        // console.log(this.currentTopic);
        console.log('Emitting saveKeyConcepts event:', {
            topicId: this.currentTopicId,
            keyConcepts: keyConcepts,
        });
        this.saveKeyConcepts.emit({ topicId: this.currentTopicId, keyConcepts });
        // Close the modal after saving
        if (this.modalRef) {
            this.modalRef.close();
        }
    }

    onSaveSubTopicSources(topic: Topic): void {
        this.saveSubTopicSources.emit({ topicId: this.currentTopicId, topic });
        this.modalService.dismissAll();
    }

    // sourcesDataEvent(sourcesData: any){
    //     this.sourcesData = sourcesData
    //     //this.saveWebUrlsFormToLocalStorage(sourcesData);
    // }

    loadTopicFromLocalStorage(): void {
        console.log('loadTopicFromLocalStorage called');
        const storedData = localStorage.getItem('topicOutline');
        //console.log("storedData", storedData);
        if (storedData) {
            const rootTopic: Topic = JSON.parse(storedData);
            const topicFound = this.findTopicById(this.currentTopicId, [rootTopic]);
            if (topicFound) {
                this.currentTopic = topicFound;
                console.log(this.currentTopic);
            } else {
                console.error('Topic ID not found.', this.topic.id);
            }
            // this.currentTopic = this.findTopicById(this.topic.id, [rootTopic]);
        }
    }

    findTopicById(topicId: number, topics: Array<Topic>): Topic | undefined {
        for (const topic of topics) {
            if (topic.id === topicId) {
                return topic;
            }
            const subtopic = this.findTopicById(topicId, topic.subtopics);
            if (subtopic) {
                return subtopic;
            }
        }
        return undefined;
    }

    // This method is called when the subtopicsUpdated event is emitted
    onSubtopicsUpdated(topics: any): void {
        console.log('Subtopics updated, refreshing data...', topics);

        for (const subtopic of topics.subtopics) {
            // localStorage.setItem('isTemplate', "true");
            subtopic.isTemplate = true;
            //  this.addParentListAndContext(subtopic);
        }

        console.log('Emitting saveKeyConcepts event:', {
            topicId: this.currentTopicId,
            topics: topics,
        });
        //debugger;
        // setTimeout(() => {
        this.saveTemplates.emit({ topicId: this.currentTopicId, topics });
        //}, 2000)
    }

    // addParentListAndContext(subtopic: any) {
    //     console.log("----------------------------------------------------------------");
    //     console.log("subtopic for adding parent context", subtopic);
    //     console.log("localStorage.getItem('isTemplate')", localStorage.getItem('isTemplate') == "true");
    //     console.log("subtopic.parentSearchContextList",subtopic.parentSearchContextList);
    //     //debugger;
    //     if (!subtopic.isOrganisationalLabel) {
    //         console.log('isOrganisationalLabel false');
    //         if(subtopic.isTemplate && subtopic.parentSearchContextList.length == 0){  // this is for template patent
    //             console.log('isOrganisationalLabel false -- if');
    //             subtopic.parentSearchContextList = [];
    //             subtopic.parentRelContextList = [];
    //             subtopic.ParentList = this.parentTopic ? this.getAllParentIds(this.topic.id) : [];
    //         }else{  // normal case
    //             console.log('isOrganisationalLabel false -- else');
    //             subtopic.parentSearchContextList = this.topic ? this.getAllParentIdsContextList(this.topic.id) : [];
    //             subtopic.parentRelContextList = this.topic ? this.getAllParentIdsContextList(this.topic.id) : [];
    //             subtopic.ParentList = this.topic ? this.getAllParentIds(this.topic.id) : [];
    //         }
    //     } else {
    //         console.log('isOrganisationalLabel true');
    //         subtopic.parentSearchContextList = [];
    //         subtopic.parentRelContextList = [];
    //         subtopic.ParentList = this.parentTopic ? this.getAllParentIds(this.topic.id) : [];
    //     }
    //     if (subtopic.isArticleCountToZero) {
    //         console.log('isArticleCountToZero true');
    //         subtopic.parentSearchContextList = [];
    //         subtopic.parentRelContextList = [];
    //         subtopic.ParentList = this.parentTopic ? this.getAllParentIds(this.topic.id) : [];
    //     }
    //     console.log(subtopic);
    //     // debugger;
    // }

    onThreeDotsHover(state: boolean): void {
        this.isThreeDotsHovered = state;
    }

    checkWidth() {
        const width = window.innerWidth;
        //console.log(width);
        if (width < 768) this.isMobile = true;
        else this.isMobile = false;
    }

    onSaveSettings(settings: any) {
        this.saveSettingsParams.emit({ topicId: this.currentTopicId, settings: JSON.parse(JSON.stringify(settings)) });
        if (this.modalRef) {
            this.modalRef.close();
        }

        console.log('settings in the component - gyan Input', JSON.parse(JSON.stringify(settings)));
    }

    ngOnDestroy() {
        this.menuSubscription.unsubscribe();
        document.removeEventListener('click', this.closeMenuOnOutsideClick.bind(this), true);
    }
}
